import { _ as __rest } from './tslib.es6-DN65qNZS.js';
import React from 'react';

const ComboboxContext = React.createContext({});
function ComboboxContextProvider(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(ComboboxContext.Provider, { value: props }, children));
}

export { ComboboxContextProvider as C, ComboboxContext as a };
